module.exports = __webpack_public_path__ + "img/boxed-12.20d03e5d.jpg";